import { BillingFrequencyEnum } from './billing-frequency-enum.generated';

const x: { [index: string]: string } = {};
x[BillingFrequencyEnum.Unknown] = 'Unknown';
x[BillingFrequencyEnum.Monthly10Pay] = 'Monthly 10 Pays';
x[BillingFrequencyEnum.Monthly11Pay] = 'Monthly 11 Pays';
x[BillingFrequencyEnum.Monthly] = 'Monthly';
x[BillingFrequencyEnum.Annually] = 'Annually';
x[BillingFrequencyEnum.SemiMonthly20Pay] = 'Semimonthly 20 Pays';
x[BillingFrequencyEnum.SemiMonthly22Pay] = 'Semimonthly 22 Pays';
x[BillingFrequencyEnum.SemiMonthly] = 'Semimonthly';
x[BillingFrequencyEnum.BiWeekly] = 'Biweekly';
x[BillingFrequencyEnum.SemiAnnually] = 'Semiannually';
x[BillingFrequencyEnum.Quarterly] = 'Quarterly';
x[BillingFrequencyEnum.Weekly] = 'Weekly';
x[BillingFrequencyEnum.WeeklyMax26] = 'Weekly Max 26 Pays';
x[BillingFrequencyEnum.BiWeekly24Ded] = 'Biweekly 24 Pays';
x[BillingFrequencyEnum.BiWeekly21Pay] = 'Biweekly 21 Pays';
x[BillingFrequencyEnum.Percentage] = '%';
x[BillingFrequencyEnum.Single] = 'Single';
x[BillingFrequencyEnum.SemiMonthly18Pay] = 'Semimonthly 18 Pays';
export const BillingFrequencyEnumDescriptions: { [indexer: string]: string } = x;
